import { mockBanner } from "../mockData/mockBanner"


export const getBanner = async () => {
  return mockBanner
}